(() => {
  const CONFIG = {
    learn: {
      after: 1,
      label: 'The landscape',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-agave-valley.png?v=1789616066',
      alt: 'Illustrative agave landscape at golden hour',
      position: '50% 56%'
    },
    'agave-spirits-101': {
      after: 1,
      label: 'Plant + place',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-agave-valley.png?v=1789616066',
      alt: 'Illustrative agave landscape at golden hour',
      position: '50% 56%'
    },
    'tequila-guide': {
      after: 1,
      label: 'Blue Weber agave',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-tequila-field.png?v=1789616002',
      alt: 'Illustrative agave field at golden hour',
      position: '50% 54%'
    },
    'mezcal-guide': {
      after: 1,
      label: 'Agave + process',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-mezcal-palenque.png?v=1789616011',
      alt: 'Illustrative mezcal production scene with agave and a copper still',
      position: '50% 51%'
    },
    'how-agave-spirits-are-made': {
      after: 0,
      label: 'From plant to spirit',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-production-process.png?v=1789616035',
      alt: 'Illustrative agave spirit production scene',
      position: '50% 51%'
    },
    'agave-production-terms': {
      after: 0,
      label: 'Production in context',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-production-process.png?v=1789616035',
      alt: 'Illustrative agave spirit production scene',
      position: '50% 51%'
    },
    'how-to-choose-agave-spirits': {
      after: 0,
      label: 'Taste first',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-tasting-table.png?v=1789616059',
      alt: 'Illustrative agave spirits tasting setup with three glasses',
      position: '50% 55%'
    },
    'high-proof-agave-spirits': {
      after: 1,
      label: 'Proof in the glass',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-tasting-table.png?v=1789616059',
      alt: 'Illustrative agave spirits tasting setup with three glasses',
      position: '50% 55%'
    },
    'additives-and-transparency': {
      after: 1,
      label: 'Process matters',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-mezcal-palenque.png?v=1789616011',
      alt: 'Illustrative agave spirit production scene',
      position: '50% 51%'
    },
    'how-to-drink-agave-spirits': {
      after: 1,
      label: 'Tasting, not ritual',
      showLabel: false,
      src: 'https://cdn.shopify.com/s/files/1/0729/7925/1274/files/rareagave-learn-tasting-table.png?v=1789616059',
      alt: 'Illustrative agave spirits tasting setup with three glasses',
      position: '50% 55%'
    }
  };

  const addEditorialPhoto = () => {
    const match = window.location.pathname.match(/\/pages\/([^/?#]+)/);
    const handle = match?.[1];
    const config = handle ? CONFIG[handle] : null;
    if (!config) return;

    const shell = document.querySelector('.ra-shell');
    if (!shell || shell.querySelector('[data-ra-learn-photo]')) return;

    const sections = Array.from(shell.children).filter((node) => node.tagName === 'SECTION');
    const anchor = sections[config.after];
    if (!anchor) return;

    const visual = document.createElement('section');
    visual.className = `ra-learn-photo${config.after === 0 ? ' ra-learn-photo--after-hero' : ''}`;
    visual.dataset.raLearnPhoto = 'true';
    visual.innerHTML = `
      <div class="ra-learn-photo__inner">
        ${config.showLabel ? `<div class="ra-learn-photo__label">${config.label}</div>` : ''}
        <figure class="ra-learn-photo__frame">
          <img src="${config.src}" alt="${config.alt}" loading="lazy" decoding="async" style="object-position:${config.position || '50% 50%'}">
        </figure>
      </div>`;

    anchor.insertAdjacentElement('afterend', visual);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addEditorialPhoto, { once: true });
  } else {
    addEditorialPhoto();
  }
})();
